import script from "./NewLoginPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewLoginPage.vue?vue&type=script&setup=true&lang=js"

import "./NewLoginPage.vue?vue&type=style&index=0&id=04815228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04815228"]])

export default __exports__